var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m12.2 6.48 4.8-3.2v9.6l-4.8-3.2v-3.2ZM1 4.88c0-1.1.9-2 2-2h7.2a2 2 0 0 1 2 2v6.4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-6.4Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgVideo;